import { ValueOfKey } from '../../../utils-types';
import { FOOD_TYPE, FoodType } from '../../constants/foodType';

/** Key order is the table's column order — `getVisibleColumns` reads it through `Object.values` */
export const FOODS_TABLE_COLUMN = {
  NAME: 'NAME',
  BRAND: 'BRAND',
  QTY: 'QTY',
  MEASUREMENT: 'MEASUREMENT',
  PROTEIN: 'PROTEIN',
  CARB: 'CARB',
  FATS: 'FATS',
  RECOMMENDATIONS: 'RECOMMENDATIONS',
  TAG: 'TAG',
  ACTIONS: 'ACTIONS',
} as const;

export type FoodsTableColumn = ValueOfKey<typeof FOODS_TABLE_COLUMN>;

export type ShowColumnsConfig = Record<FoodsTableColumn, boolean>;

// Fixed tracks are the design's cell boxes minus the row's 24px gap; the fluid ones keep the design's
export const COLUMN_WIDTHS: Record<FoodsTableColumn, string> = {
  NAME: 'minmax(180px, 1.5fr)',
  BRAND: 'minmax(124px, 1fr)',
  QTY: 'minmax(48px, 0.5fr)',
  MEASUREMENT: 'minmax(140px, 1fr)',
  PROTEIN: 'minmax(80px, 0.5fr)',
  CARB: 'minmax(80px, 0.5fr)',
  FATS: 'minmax(80px, 0.5fr)',
  RECOMMENDATIONS: '118px',
  TAG: 'minmax(124px, 1fr)',
  ACTIONS: 'auto',
};

const commonShowColumnsConfig: ShowColumnsConfig = {
  [FOODS_TABLE_COLUMN.NAME]: true,
  [FOODS_TABLE_COLUMN.BRAND]: false,
  [FOODS_TABLE_COLUMN.QTY]: true,
  [FOODS_TABLE_COLUMN.MEASUREMENT]: true,
  [FOODS_TABLE_COLUMN.PROTEIN]: true,
  [FOODS_TABLE_COLUMN.CARB]: true,
  [FOODS_TABLE_COLUMN.FATS]: true,
  [FOODS_TABLE_COLUMN.RECOMMENDATIONS]: true,
  [FOODS_TABLE_COLUMN.TAG]: true,
  [FOODS_TABLE_COLUMN.ACTIONS]: true,
};

export const SHOW_COLUMNS_BY_TYPE: Record<FoodType, ShowColumnsConfig> = {
  [FOOD_TYPE.CORE]: commonShowColumnsConfig,
  [FOOD_TYPE.SUPPLEMENT]: {
    ...commonShowColumnsConfig,
    [FOODS_TABLE_COLUMN.BRAND]: true,
  },
  [FOOD_TYPE.VEGGIES]: commonShowColumnsConfig,
  [FOOD_TYPE.BARCODE]: commonShowColumnsConfig,
};
